import { render, staticRenderFns } from "./KnownActionTranslationsPage.vue?vue&type=template&id=4a6cd654&"
import script from "./KnownActionTranslationsPage.vue?vue&type=script&lang=js&"
export * from "./KnownActionTranslationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports